"use client";

import { c as _c } from "react/compiler-runtime";
import { Switch } from "@base-ui/react/switch";
import type React from "react";
import { cn } from "@/lib/utils";
const sizes = {
  md: {
    root: "h-5 w-8",
    thumb: "size-4 data-checked:translate-x-3"
  },
  sm: {
    root: "h-4 w-6",
    thumb: "size-3 data-checked:translate-x-2"
  }
};
type StyledSwitchProps = React.ComponentPropsWithoutRef<typeof Switch.Root> & {
  ref?: React.Ref<React.ComponentRef<typeof Switch.Root>>;
  size?: keyof typeof sizes;
};
function StyledSwitch(t0) {
  const $ = _c(17);
  let className;
  let props;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      ref,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = ref;
    $[4] = t1;
  } else {
    className = $[1];
    props = $[2];
    ref = $[3];
    t1 = $[4];
  }
  const size = t1 === undefined ? "md" : t1;
  const t2 = sizes[size];
  let t3;
  if ($[5] !== className || $[6] !== t2.root) {
    t3 = cn("relative flex shrink-0 cursor-pointer items-center rounded-full bg-gray-400 p-0.5 transition-colors duration-200 ease-out disabled:cursor-not-allowed disabled:opacity-50 data-checked:bg-sky-400", t2.root, className);
    $[5] = className;
    $[6] = t2.root;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = sizes[size];
  let t5;
  if ($[8] !== t4.thumb) {
    t5 = cn("rounded-full bg-white shadow-custom transition-transform duration-200 ease-out", t4.thumb);
    $[8] = t4.thumb;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <Switch.Thumb className={t5} />;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props || $[13] !== ref || $[14] !== t3 || $[15] !== t6) {
    t7 = <Switch.Root className={t3} ref={ref} {...props}>{t6}</Switch.Root>;
    $[12] = props;
    $[13] = ref;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}
export { StyledSwitch as Switch };